export { default } from './CaseTile';



// WEBPACK FOOTER //
// ./src/components/atoms/CaseTile/index.js